import component from "./PrintingStation";

export default component;
